import React from 'react';
import ValidationRulesList from './ValidationRulesList';
/**
 * Route wrapper for the validation-rule administration screen (CZNA-245).
 * The list owns selection/create state via the URL query string, so this
 * wrapper is a thin pass-through (no nested :id routes needed).
 */
var ValidationRules = function () { return React.createElement(ValidationRulesList, null); };
export default ValidationRules;
